<div>
  <div *ngFor="let cat of categories$ | async">
    <div class="category">
      <div>{{ cat.name }}</div>
      <div class="actions">
        <button
          mat-raised-button
          color="primary"
          [routerLink]="['/categories', cat.id]"
        >
          Bearbeiten
        </button>
      </div>
    </div>
  </div>

  <button mat-raised-button routerLink="/categories/new">
    Kategorie hinzufügen
  </button>
</div>
